import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";

import * as Actions from "../../store/actions";

export const useActionsHook = () => {
  const dispatch = useDispatch();
  return bindActionCreators(Actions, dispatch);
};
